/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import { Alert } from "UpduoLibrary";

export function showUpdateAlert(responseObject: {
  title?: string;
  message?: string;
}) {
  // Alert user to update the app (or of impending required update)
  if (responseObject.title && responseObject.message) {
    Alert(responseObject.title, responseObject.message, [
      {
        text: "Okay",
        onPress: () => {
          window.location.reload();
        },
      },
    ]);
  }
}
